module.exports = __webpack_public_path__ + "static/media/icons_menu.8d87a508.svg";